import React from 'react'
import { useParams } from 'react-router-dom'

import { BulletinListResponse } from '../../../common/generated/residentApiSchemas'
import { useAPIGetBulletinBoardBulletins } from '../../api/apiHooks/useAPIGetBulletinBoardBulletins'

interface BulletinBoardDataLoaderProps {
  children: (props: {
    bulletins: BulletinListResponse['bulletins']
  }) => React.ReactNode
}

export const BulletinBoardDataLoader: React.FC<
  BulletinBoardDataLoaderProps
> = ({ children }) => {
  const { contractId } = useParams<{ contractId: string }>()

  const { bulletins } = useAPIGetBulletinBoardBulletins({
    contractId: contractId!,
  })

  return children({ bulletins })
}
